import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import type { AccountData } from '../../api/models/AccountData';
import type { OrderData } from '../../api/models/OrderData';
import { SessionCard } from './SessionCard';
import { ScheduleSession } from '../hooks/usePassScheduleData';
import { sessionSelectionKey } from '../../shared/passDatedSessionPicker/utils';

type ScheduleDayGroupProps = {
  date: string;
  sessions: ScheduleSession[];
  account?: AccountData;
  orders?: OrderData[];
  onCancel?: (session: ScheduleSession) => void;
  onBook?: (session: ScheduleSession) => void;
  onCancelWaitlist?: (session: ScheduleSession) => void;
  selectable?: boolean;
  selectedKeys?: Set<string>;
  selectionFull?: boolean;
  onToggle?: (session: ScheduleSession) => void;
};

export const ScheduleDayGroup = ({
  date,
  sessions,
  account,
  orders,
  onCancel,
  onBook,
  onCancelWaitlist,
  selectable,
  selectedKeys,
  selectionFull,
  onToggle,
}: ScheduleDayGroupProps) => {
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === 'rtl';
  const format = isRtl ? 'dddd, D/M' : 'dddd, MM/DD';

  return (
    <Grid container flexDirection="column" gap={1.5}>
      <Divider />
      <Typography variant="h6" color="text.secondary" textAlign="center" fontWeight={700}>
        {moment(date).format(format)}
      </Typography>
      {sessions.map((session, idx) => {
        const isSelected = !!selectedKeys?.has(sessionSelectionKey(session));
        const guestOrderId = session.registeredOrder?.guest_order_id;
        return (
          <SessionCard
            key={`${session.eventId || session.orderPageId}-${idx}`}
            session={session}
            account={account}
            guestOrder={guestOrderId ? orders?.find((order) => order.id === guestOrderId) : undefined}
            selectable={selectable}
            selected={isSelected}
            disabled={!!selectionFull && !isSelected}
            onToggle={onToggle}
            onCancel={onCancel}
            onBook={onBook}
            onCancelWaitlist={onCancelWaitlist}
          />
        );
      })}
    </Grid>
  );
};
